import { AemConfigurationThirdpartySocialLoginProvider } from '../AemConfigurationTypes';
import { ErrorMessage } from '../enums';

export type AuthenticationState = {
  authenticated: boolean;
  loading: boolean;
  loadingGuest?: boolean;
  loadingReturnGuest?: boolean;
  error?: ErrorMessage | null;
  errorGuest?: ErrorMessage | null;
  errorReturnGuest?: ErrorMessage | null;
  resetPassword: {
    error?: string | null;
    success?: string | null;
  };
  social: {
    initialized: Array<AemConfigurationThirdpartySocialLoginProvider>;
  };
  loggedGuest: boolean;
  loggedInReturnGuest: boolean;
};

export type AuthUserinfoResponse = {
  sub: string;
  given_name: string;
  family_name: string;
  preferred_username: string;
  email: string;
  market: 'be' | 'nl' | 'uk';
  shop_id: number;
};
